/* src/app/admin-dashboard/company-sites/blankcomponent/blankcomponent.component.css */
.center {
  text-align: center;
}
/*# sourceMappingURL=blankcomponent.component.css.map */
